module.exports = {
  "zones": {
    "Pacific/Saipan": ["z", {
      "wallclock": 977529600000,
      "format": "ChST",
      "abbrev": "ChST",
      "offset": 36000000,
      "posix": 977493600000,
      "save": 0
    }, {
      "wallclock": -802224000000,
      "format": "G%sT",
      "abbrev": "GST",
      "offset": 36000000,
      "posix": -802256400000,
      "save": 0,
      "rules": "Guam"
    }, {
      "wallclock": -885513600000,
      "format": "+09",
      "abbrev": "+09",
      "offset": 32400000,
      "posix": -885549600000,
      "save": 0
    }, {
      "wallclock": -2177452800000,
      "format": "GST",
      "abbrev": "GST",
      "offset": 36000000,
      "posix": -2177487540000,
      "save": 0
    }, {
      "wallclock": -3944678400000,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 34740000,
      "posix": -3944626740000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -51660000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Guam": [{
      "from": 1977,
      "to": 1977,
      "month": 3,
      "day": [7, 24],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1977,
      "to": 1977,
      "month": 7,
      "day": [7, 28],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1976,
      "to": 1976,
      "month": 4,
      "day": [7, 26],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1976,
      "to": 1976,
      "month": 7,
      "day": [7, 22],
      "time": 121,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1974,
      "to": 1974,
      "month": 1,
      "day": [7, 24],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1973,
      "to": 1973,
      "month": 11,
      "day": [7, 16],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1970,
      "to": 1971,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1970,
      "to": 1971,
      "month": 8,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1969,
      "to": 1969,
      "month": 0,
      "day": [7, 26],
      "time": 1,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1969,
      "to": 1969,
      "month": 5,
      "day": [7, 22],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1969,
      "to": 1969,
      "month": 7,
      "day": [7, 31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1967,
      "to": 1967,
      "month": 8,
      "day": [7, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1961,
      "to": 1961,
      "month": 0,
      "day": [7, 29],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1959,
      "to": 1959,
      "month": 5,
      "day": [7, 27],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }]
  }
};